import React from "react";
import Register from "../../components/register/Register";

const RegisterPage = () => {
  return (
    <div>
      <Register />
    </div>
  );
};

export default RegisterPage;
